import React, { useMemo } from 'react';
import useResizeBodyObserver from 'hooks/useResizeBodyObserver';
import { EScreenMode } from 'types/screenMode';
import { EPageScreenModes, MOBILE } from 'constants/screenSizes';
import { IAppContext } from './types';

const AppContext = React.createContext<IAppContext>({
  mode: EScreenMode.Desktop,
  bodyWidth: EPageScreenModes.DesktopMedium,
});

export const AppContextProvider: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const { width: bodyWidth } = useResizeBodyObserver();

  const mode =
    bodyWidth <= MOBILE[1] && bodyWidth >= MOBILE[0]
      ? EScreenMode.Mobile
      : EScreenMode.Desktop;

  const value = useMemo(
    () => ({
      mode,
      bodyWidth,
    }),
    [bodyWidth, mode],
  );

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export const useAppContext = () => React.useContext(AppContext);
